import { useEffect, useMemo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { TableCustomCell } from 'src/app/modules/component/table/components/TableCustomCell';
import { TableCustomHeader } from 'src/app/modules/component/table/components/TableCustomHeader';
import { TablePagination } from 'src/app/modules/component/table/components/TablePagination';
import { TableCustom } from 'src/app/modules/component/table/table-custom/TableCustom';
import SearchField from 'src/app/modules/phan-he-kham-benh/components/tab-kham-benh/modal-chon-ket-qua-dich-vu/components/SearchField';
import { RESPONSE_MESSAGE, SELECTION_MODE } from 'src/app/modules/utils/Constant';
import { formatDateTime } from 'src/app/modules/utils/FormatUtils';
import {
	handlePagesChange,
	handleRowsPerPageChange,
	rowsForPage,
} from 'src/app/modules/utils/PageUtils';
import {
	getDetailPhieuDieuTri,
	getDsPhieuDieuTri,
} from 'src/app/modules/phan-he-kham-benh/services/BenhAnServices';

type Props = {
	open: boolean;
	onClose: () => void;
	onSave: (selectedRow: any) => void;
	params: {
		patientId: string;
		visitId: string;
		medicalRecordCode: string;
	};
};

const PhieuDieuTriDialog = ({ open, onClose, onSave, params }: Props) => {
	const [configTable, setConfigTable] = useState<any>({
		totalPages: 0,
		totalElements: 0,
		numberOfElements: 0,
	});
	const [page, setPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const [selectedRow, setSelectedRow] = useState<any[]>([]);
	const [data, setData] = useState([]);

	const COLUMNS = useMemo(
		() => [
			{
				Header: (props: any) => (
					<TableCustomHeader
						tableProps={props}
						title="STT"
						className="text-center text-white px-3 min-w-60"
					/>
				),
				id: 'index',
				Cell: ({ ...props }: any) => (
					<TableCustomCell data={props?.row?.original?.index} className="text-center" />
				),
			},
			{
				Header: (props: any) => (
					<TableCustomHeader
						tableProps={props}
						title="Tên Phiếu"
						className="text-center text-white spaces min-w-100"
					/>
				),
				id: 'createdDate',
				Cell: ({ ...props }: any) => (
					<TableCustomCell
						data={formatDateTime(props?.row?.original?.createdDate)}
						className="text-center"
					/>
				),
			},
            {
				Header: (props: any) => (
					<TableCustomHeader
						tableProps={props}
						title="Người nhập"
						className="text-center text-white spaces min-w-200"
					/>
				),
				id: 'createdBy',
				Cell: ({ ...props }: any) => (
					<TableCustomCell
						data={props?.row?.original?.createdBy}
						className="text-center"
					/>
				),
			},
		],
		[]
	);

	useEffect(() => {
		getData(params);
	}, []);

	const getData = async (params?: any) => {
		try {
			const { data } = await getDsPhieuDieuTri(params);
			const listTemp = data.data.map((item: any, index: number) => ({
				...item,
				value: item.id,
				name: formatDateTime(item.createdDate),
				index: index + 1,
			}));
			setConfigTable({
				totalPages: data?.data?.pageable?.pageNumber + 1,
				totalElements: data?.data?.pageable?.totalElements,
				numberOfElements: data?.data?.pageable?.pageNumber,
			});
			setData(listTemp);
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const onSelect = async () => {
		try {
			if (!selectedRow.length) return;

			const { data } = await getDetailPhieuDieuTri(selectedRow[0].id);
			onSave(data.data);
		} catch (error) {
			console.error(error);
		}
	};

	const onSearch = (value: string) => {
		getData({
			...params,
			keySearch: value,
		});
	};

	return (
		<Modal
			dialogClassName="h-modal"
			size="lg"
			show={open}
			animation={false}
			centered
			backdropClassName="spaces top-50"
			onHide={onClose}
		>
			<Modal.Header closeButton>
				<Modal.Title>Cập nhật từ phiếu điều trị</Modal.Title>
			</Modal.Header>

			<Modal.Body className="bg-white">
				<SearchField onSearch={onSearch} />
				<TableCustom
					columns={COLUMNS}
					data={data}
					selectionMode={SELECTION_MODE.SINGLE}
					minHeight={200}
					verticalScroll={true}
					getSelectedRowsData={setSelectedRow}
					rowSelected={[selectedRow]}
				/>
				<TablePagination
					handlePagesChange={handlePagesChange}
					handleRowsPerPageChange={handleRowsPerPageChange}
					rowsPerPage={rowsPerPage}
					rowsForPage={rowsForPage}
					page={page}
					setPage={setPage}
					setRowsPerPage={setRowsPerPage}
					totalPages={configTable.totalPages}
					totalElements={configTable.totalElements}
					numberOfElements={configTable.numberOfElements}
					className="border border-0"
				/>
			</Modal.Body>

			<Modal.Footer>
				<div className="d-flex justify-content-end" onClick={onSelect}>
					<Button className="btn-fill spaces min-w-60">Xác nhận</Button>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export default PhieuDieuTriDialog;
